import { render, staticRenderFns } from "./Overdue.vue?vue&type=template&id=d1ed8dcc&"
import script from "./Overdue.vue?vue&type=script&lang=js&"
export * from "./Overdue.vue?vue&type=script&lang=js&"
import style0 from "./Overdue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports